import React from 'react';
import Select from 'react-select';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { Form, Row, Col, Button } from 'react-bootstrap';
import axios from '../../../axios';
import { toast } from 'react-toastify';

export default function StepOne({handlers,data}) {
    const options = data.options;
    const availableDates = () => {
        let tempDates = data.serviceData.datesAllowed.split(',');
        return tempDates.map(date => {return {label: date, value: date}});
    };
    const validationSchema = Yup.object().shape({
        childId: Yup.string().required('Required'),
        dates: Yup.array().of(Yup.string()).min(1, 'Minimum 1 date required').required('required'),
        notes: Yup.string()
    });

    const onSubmit = (values) => {
        let checkData = {
            serviceId: data.serviceData.serviceId,
            childId: parseInt(values.childId),
            dates: values.dates.toString()
        };
        axios.post('/check-bookings', checkData, {
            headers: {
                'Authorization': `Bearer ${data.authToken}`
            }
        })
        .then((response) => {
            if (response.status === 200) {
                handlers.goToNextStep(values);
            } else {
                toast.warn('No response from server');
            }
        })
        .catch((error) => {
            if (error.response.status === 403) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong');
            }
            console.log(error);
        })
    };

    return (
        <Formik
            initialValues={data.bookingData}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {({
                values,
                setFieldValue,
                handleChange,
                handleSubmit
            }) => (
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md='6' className="mb-2">
                            <Form.Label>Select Child:</Form.Label>
                            <Select
                                name='childId'
                                options={options}
                                isSearchable={false}
                                isClearable={false}
                                onChange={(opt) => {
                                    setFieldValue('childId', opt.value);
                                    handlers.setChildName(opt.label);
                                }}
                            />
                            <ErrorMessage name='childId' component='p' className='error-message' />
                        </Col>
                        <Col md='6'>
                            <Form.Label>Dates</Form.Label>
                            <Select
                                name="dates"
                                className="mb-3"
                                options={availableDates()}
                                isSearchable={false}
                                onChange={(opts) => {
                                    setFieldValue('dates', opts.map(obj => obj.value));
                                }}
                                isMulti
                            />
                            <ErrorMessage name='dates' component='p' className='error-message' />
                        </Col>
                    </Row>
                    <Form.Group
                        className="mb-3"
                    >
                        <Form.Label>Note</Form.Label>
                        <Form.Control 
                            as="textarea"
                            name="notes" 
                            placeholder="Have anything to tell us?" 
                            rows={3} 
                            value={values.notes}
                            onChange={handleChange}
                        />
                        <ErrorMessage name='notes' component='p' className='error-message' />
                    </Form.Group>
                    <div className='form-foot d-flex justify-content-end'>
                        <Button variant="secondary" size="md" type="button" onClick={handlers.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" size="md" type="submit" className="ms-3">
                            Proceed to Checkout
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
